enum SystemMessage {
    INVALID_FILES_FOR_DOCUMENT_UPLOAD = "systemMessage.invalid_files_document_upload",
    INVALID_FILES_FOR_IMAGE_UPLOAD = "systemMessage.invalid_files_image_upload",
    MAX_DOCUMENTS_UPLOADED = "systemMessage.max_documents_uploaded",
    MAX_IMAGES_UPLOADED = "systemMessage.max_images_uploaded",
    DOCUMENT_OVER_SIZE_LIMIT = "systemMessage.document_too_large",
    INVALID_FILES_FOR_TEMPLATE = "systemMessage.invalid_files_uploaded",
    DOCUMENT_DELETED = "systemMessage.document_deleted",
    CHECKLIST_DELETED = "systemMessage.checklist_deleted",
    IMAGE_DELETED = "systemMessage.image_deleted",
    COMMENT_ADDED = "systemMessage.comment_added",
    COMMENT_FAILED = "systemMessage.comment_failed",
    PROCESSING_CHECKLIST = "systemMessage.processing_checklist",
    INVALID_FILE_NAME = "systemMessage.invalid_file_name",
    IMAGE_FILES_TOO_LARGE = "systemMessage.files_size_limit",
    FILES_ZERO_BYTE = "systemMessage.files_zero_byte"
}

enum InspectionSentences {
    MARK_COMPLETE_MODAL_TITLE = "inspection.markCompleteModal.title",
    MARK_COMPLETE_MODAL_FIRST_PARGRAPH = "inspection.markCompleteModal.first_paragraph",
    MARK_COMPLETE_MODAL_SECOND_PARGRAPH = "inspection.markCompleteModal.second_paragraph",
    MARK_COMPLETE_MODAL_THIRD_PARGRAPH = "inspection.markCompleteModal.third_paragraph",
    MARK_COMPLETE_MODAL_WARNING_MESSAGE = "inspection.markCompleteModal.warning_text",
    MARK_COMPLETE_MODAL_BUTTON_TEXT = "inspection.markCompleteModal.button_text",
    INSPECTION_COMPLETE_MODAL_TITLE = "inspection.inspectionCompleteModal.title",
    INSPECTION_COMPLETE_MODAL_BODY = "inspection.inspectionCompleteModal.body",
    INSPECTION_COMPLETE_MODAL_BUTTON = "inspection.inspectionCompleteModal.done",
    INSPECTION_COMPLETE_EMAIL_ADDRESS = "inspection.inspectionCompleteModal.email_address"
}

enum VesselContactSentences {
    MARK_COMPLETE_VC_MODAL_TITLE = "inspection.vesselContactMarkCompleteModal.title",
    MARK_COMPLETE_VC_MODAL_FIRST_PARAGRAPH = "inspection.vesselContactMarkCompleteModal.first_paragraph",
    MARK_COMPLETE_VC_MODAL_SECOND_PARAGRAPH = "inspection.vesselContactMarkCompleteModal.second_paragraph",
    MARK_COMPLETE_VC_MODAL_WARNING_MESSAGE = "inspection.vesselContactMarkCompleteModal.warning_text",
    MARK_COMPLETE_VC_MODAL_BUTTON_TEXT = "inspection.vesselContactMarkCompleteModal.button_text",
    MARK_COMPLETE_VC_SUBMISSION_ERROR = "inspection.vesselContactMarkCompleteModal.submission_error",
    MARK_COMPLETE_VC_SUBMISSION_SUCCESS = "inspection.vesselContactMarkCompleteModal.submission_success"
}

enum HoldingPageMessages {
    VERIFYING = "holdingPage.verifying",
    FAILED = "holdingPage.failed"
}

export {
    SystemMessage,
    InspectionSentences,
    HoldingPageMessages,
    VesselContactSentences
};
